import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import PlatformReportResolver from 'reporting-ui-components/components/PlatformReport/PlatformReportResolver';
import { ReportType } from 'reporting-ui-components/types/ReportTypes';
import useConfigureReportWithCheckboxes from './useConfigureReportWithCheckboxes';
import { DEFAULT_TABLE_LIMIT_FOR_CHECKBOX_TABLE } from './utils';
import { jsx as _jsx } from "react/jsx-runtime";
const SingleReportViewerCheckboxTableViz = ({
  previewReport,
  onPreviewReportChange,
  refreshCount,
  reportErrorRenderer,
  selectedDimension,
  onGenerateCheckboxTableReport,
  initialRowLimit,
  is2DSupported
}) => {
  const [rowLimit, setRowLimit] = useState(initialRowLimit || DEFAULT_TABLE_LIMIT_FOR_CHECKBOX_TABLE);
  const reportWithCheckboxes = useConfigureReportWithCheckboxes(previewReport, onPreviewReportChange, rowLimit, setRowLimit, is2DSupported, selectedDimension);
  useEffect(() => {
    if (onGenerateCheckboxTableReport && reportWithCheckboxes) {
      onGenerateCheckboxTableReport(reportWithCheckboxes);
    }
  }, [reportWithCheckboxes, onGenerateCheckboxTableReport]);
  if (!reportWithCheckboxes) {
    return null;
  }
  return /*#__PURE__*/_jsx(PlatformReportResolver, {
    lazyReportResolve: false,
    errorRenderer: reportErrorRenderer,
    report: reportWithCheckboxes,
    trackingAssetType: "srv-checkbox-table",
    useInlineLabels: false,
    enableReportResolveUsageTracking: false
  }, refreshCount);
};
SingleReportViewerCheckboxTableViz.propTypes = {
  previewReport: ReportType.isRequired,
  onPreviewReportChange: PropTypes.func.isRequired,
  refreshCount: PropTypes.number,
  reportErrorRenderer: PropTypes.func,
  onReportResolve: PropTypes.func
};
export default SingleReportViewerCheckboxTableViz;